// Put your application javascript here

document.addEventListener('DOMContentLoaded', () => {
  const btn = document.getElementById('menu-btn');
  const menu = document.getElementById('menu')
  const menuClose = document.getElementById('menu-close');
  const mainMenu = document.getElementById('main-menu');

  if (btn && menu) {
    btn.addEventListener('click', navToggle)
  }

  function navToggle() {
    if (btn && menu) {
      btn.classList.toggle('open')
      menu.classList.toggle('flex')
      menu.classList.toggle('hidden')
    }
  }

  // Function to hide all submenus and show main menu
  function resetToMainMenu() {
    const allSubmenus = document.querySelectorAll('.mobile-submenu');
    allSubmenus.forEach(submenu => {
      submenu.classList.add('hidden');
      submenu.classList.remove('flex');
    });
    if (mainMenu) {
      mainMenu.classList.remove('hidden');
    }
  }

  // Close button functionality
  if (menuClose && menu) {
    menuClose.addEventListener('click', () => {
      if (btn) {
        btn.classList.remove('open');
      }
      menu.classList.remove('flex');
      menu.classList.add('hidden');
      // Reset to main menu when closing
      resetToMainMenu();
    });
  }

  // Dynamic submenu toggle - works with any menu item that has children
  const menuButtons = document.querySelectorAll('.mobile-menu-btn');
  menuButtons.forEach(menuBtn => {
    menuBtn.addEventListener('click', () => {
      const submenuId = menuBtn.getAttribute('data-submenu-id');
      const submenu = document.getElementById(submenuId);
      
      if (submenu && mainMenu) {
        mainMenu.classList.add('hidden');
        submenu.classList.remove('hidden');
        submenu.classList.add('flex');
      }
    });
  });

  // Dynamic back button functionality - works with any submenu
  const backButtons = document.querySelectorAll('.mobile-back-btn');
  backButtons.forEach(backBtn => {
    backBtn.addEventListener('click', () => {
      const submenuId = backBtn.getAttribute('data-submenu-id');
      const submenu = document.getElementById(submenuId);
      
      if (submenu) {
        submenu.classList.add('hidden');
        submenu.classList.remove('flex');
      }
      if (mainMenu) {
        mainMenu.classList.remove('hidden');
      }
    });
  });

  // --- Popover navbar background handling ---
  // Uses handleNavbarScroll from navbar.js
  const navbar = document.getElementById('navbar');
  const navTexts = navbar ? navbar.querySelectorAll('.nav-text') : [];

  // Handle all desktop menu popovers (best-sellers, clothing, etc.)
  const allPopovers = document.querySelectorAll('[id^="desktop-menu-"]');
  const allTriggers = document.querySelectorAll('[popovertarget^="desktop-menu-"]');

  // Function to set navbar to white background
  function setNavbarWhite() {
    if (!navbar) return;
    navbar.classList.remove('bg-transparent');
    navbar.classList.add('bg-white');
    navTexts.forEach(el => {
      el.classList.remove('text-white');
      el.classList.add('text-gray-900');
    });
  }

  // Function to restore navbar background based on scroll position
  function restoreNavbarBackground() {
    // Use the global handleNavbarScroll function from navbar.js
    if (window.handleNavbarScroll) {
      window.handleNavbarScroll();
    }
  }

  // Track hover timeout for menu items
  let menuHoverTimeout = null;

  // Helper function to check if mouse is over any nav element
  function isMouseOverAnyNavElement() {
    return Array.from(navTexts).some(el => el.matches(':hover'));
  }

  // Helper function to close all open popovers
  function closeAllPopovers() {
    allPopovers.forEach(popover => {
      if (popover.matches(':popover-open')) {
        popover.hidePopover();
      }
    });
  }

  // Add hover functionality to all nav-text elements (including links without popovers)
  navTexts.forEach(element => {
    // Skip if it's already a popover trigger (handled below)
    if (element.hasAttribute('popovertarget')) return;
    
    element.addEventListener('mouseenter', () => {
      // Clear any pending timeout
      if (menuHoverTimeout) {
        clearTimeout(menuHoverTimeout);
        menuHoverTimeout = null;
      }
      // Close any open popovers when hovering over non-popover menu items
      closeAllPopovers();
      setNavbarWhite();
    });
    
    element.addEventListener('mouseleave', () => {
      // Clear any existing timeout
      if (menuHoverTimeout) {
        clearTimeout(menuHoverTimeout);
      }
      
      // Add a small delay to check if mouse moved to another nav element
      menuHoverTimeout = setTimeout(() => {
        // Check if mouse is still over any nav element or popover
        const anyPopoverOpen = Array.from(allPopovers).some(p => p.matches(':popover-open'));
        const stillOverNav = isMouseOverAnyNavElement();
        
        if (!stillOverNav && !anyPopoverOpen) {
          // Only restore if not scrolled down
          if (window.scrollY <= 50) {
            restoreNavbarBackground();
          } else {
            // If scrolled down, keep it white
            setNavbarWhite();
          }
        }
        menuHoverTimeout = null;
      }, 50); // Small delay to allow mouse to move to adjacent element
    });
  });

  // Setup popover handlers for each popover
  allPopovers.forEach(popover => {
    if (!popover || !popover.showPopover || !navbar) return;
    
    const popoverId = popover.id;
    const triggers = Array.from(allTriggers).filter(btn => btn.getAttribute('popovertarget') === popoverId);
    
    if (triggers.length === 0) return;
    
    let hoverTimeout;
    function openPopover() {
      clearTimeout(hoverTimeout);
      // Close any other open popovers first
      allPopovers.forEach(otherPopover => {
        if (otherPopover !== popover && otherPopover.matches(':popover-open')) {
          otherPopover.hidePopover();
        }
      });
      popover.showPopover();
      // Set navbar to white when popover opens
      setNavbarWhite();
    }

    function scheduleClose() {
      hoverTimeout = setTimeout(() => {
        const stillOverNav = isMouseOverAnyNavElement();
        if (!popover.matches(':hover') && !isAnyTriggerHovered() && !stillOverNav) {
          popover.hidePopover();
          // Restore navbar background based on scroll when popover closes
          if (window.scrollY <= 50) {
            restoreNavbarBackground();
          } else {
            setNavbarWhite();
          }
        }
      }, 100);
    }

    function isAnyTriggerHovered() {
      return triggers.some(btn => btn.matches(':hover'));
    }

    triggers.forEach(btn => {
      btn.addEventListener('mouseenter', () => {
        // Clear any pending timeout
        if (menuHoverTimeout) {
          clearTimeout(menuHoverTimeout);
          menuHoverTimeout = null;
        }
        setNavbarWhite(); // Turn navbar white immediately on hover
        openPopover();
      });
      btn.addEventListener('mouseleave', () => {
        // Clear any existing timeout
        if (menuHoverTimeout) {
          clearTimeout(menuHoverTimeout);
        }
        
        // Add a small delay to check if mouse moved to another nav element
        menuHoverTimeout = setTimeout(() => {
          const stillOverNav = isMouseOverAnyNavElement();
          if (!stillOverNav) {
            scheduleClose();
          }
          menuHoverTimeout = null;
        }, 50);
      });
    });

    popover.addEventListener('mouseenter', () => {
      clearTimeout(hoverTimeout);
      // Keep navbar white while hovering popover
      setNavbarWhite();
    });
    popover.addEventListener('mouseleave', () => {
      // Check if mouse moved to a nav element before closing
      setTimeout(() => {
        const stillOverNav = isMouseOverAnyNavElement();
        if (!stillOverNav) {
          scheduleClose();
        }
      }, 50);
    });

    // Handle popover close events (when clicking outside or pressing ESC)
    popover.addEventListener('toggle', (e) => {
      if (!e.newState) {
        // Popover is closing
        restoreNavbarBackground();
      }
    });

    // Handle clicks outside the popover
    document.addEventListener('click', (e) => {
      if (popover.matches(':popover-open')) {
        const isClickInsidePopover = popover.contains(e.target);
        const isClickOnTrigger = triggers.some(btn => btn.contains(e.target));
        
        if (!isClickInsidePopover && !isClickOnTrigger) {
          popover.hidePopover();
          restoreNavbarBackground();
        }
      }
    });
  });
});
